import { G2S } from '../g2s';
import * as api from '../api';

export class SupportService {
    create(request: FormData): Promise<api.SupportCreateResult> {
        return new Promise<api.SupportCreateResult>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Support/Create',
                    request,
                    {
                        withCredentials: true,
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        }
                    }
                )
                .then(function (response) {
                    resolve(<api.SupportCreateResult>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    getReservationsSupportInformation(marketCode: string, locale: string): Promise<api.SupportGetReservationsSupportInformationResult> {
        return new Promise<api.SupportGetReservationsSupportInformationResult>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Support/GetReservationsSupportInformation',
                    {
                        marketCode,
                        locale
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.SupportGetReservationsSupportInformationResult>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    getReservationData(reservationId: string): any {
        return new Promise<any>((resolve, reject) => {
            G2S
                .$http
                .get(
                    `/api/support/GetReservationData?reservationId=${reservationId}`,
                    // {
                    //     reservationId: reservationId,
                    // },
                    // {
                    //     withCredentials: true,
                    //     headers: {
                    //         'ticketForm': 'new',
                    //     }
                    // },
                )
                .then(function (response) {
                    resolve(<any>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    checkReservationEmail(reservationId: string, email: string): Promise<{isSameEmail: boolean}> {
        return new Promise<{isSameEmail: boolean}>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Support/CheckReservationEmail',
                    {
                        reservationId,
                        email
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<{isSameEmail: boolean}>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    getHistory(marketCode: string, locale: string): Promise<api.SupportGetHistoryResult> {
        return new Promise<api.SupportGetHistoryResult>((resolve, reject) => {
            G2S
                .$http
                .post(
                    '/api/Support/GetHistory',
                    {
                        marketCode,
                        locale
                    },
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.SupportGetHistoryResult>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    getRefundInfo(publicId: string): Promise<api.SbpRefundInfo> {
        return new Promise<api.SbpRefundInfo>((resolve, reject) => {
            G2S
                .$http
                .get(
                    `/api/PaymentRefundApproval/${publicId}`,
                    {
                        withCredentials: true
                    }
                )
                .then(function (response) {
                    resolve(<api.SbpRefundInfo>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }
    
    submitRefundInfo(request: api.SubmitSbpRefundRequest): Promise<api.SbpRefundInfo> {
        return new Promise<api.SbpRefundInfo>((resolve, reject) => {
            G2S
                .$http
                .post(
                    `/api/PaymentRefundApproval/`,
                    request,
                    {
                        withCredentials: true
                    }
                )
                .then((response) => {
                    resolve(<api.SbpRefundInfo>response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }
}
